export default __webpack_public_path__ + "static/img/UK-DION-LOGISTICS-LOGO-01.591837c.png";